import React, { useState } from "react";
import "./Quiz.css";

function Quiz({ questions, endQuiz }) {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);

  const handleNext = () => {
    if (selectedOption === null) return;
    if (selectedOption === questions[currentQuestion].answer) {
      setScore(score + 1);
    }
    setSelectedOption(null);

    if (currentQuestion + 1 < questions.length) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      endQuiz(score + (selectedOption === questions[currentQuestion].answer ? 1 : 0));
    }
  };

  return (
    <div className="quiz-container">
      <h2>Question {currentQuestion + 1} of {questions.length}</h2>
      <h3>{questions[currentQuestion].question}</h3>
      <ul className="options-list">
        {questions[currentQuestion].options.map((option, index) => (
          <li
            key={index}
            onClick={() => setSelectedOption(index)}
            className={`option-item ${selectedOption === index ? "selected" : ""}`}
          >
            {option}
          </li>
        ))}
      </ul>
      <button
        onClick={handleNext}
        disabled={selectedOption === null}
        className="next-button"
      >
        {currentQuestion + 1 === questions.length ? "Finish" : "Next"}
      </button>
    </div>
  );
}

export default Quiz;
